import {
  Button,
  ChairAltOutlinedIcon,
  DesktopWindowsOutlinedIcon,
  Flex,
  Text,
  VisibilityOutlinedIcon,
} from '@shared/components';
import React from 'react';

interface ExamRoomDetailsBarProps {
  examRoomDetailType: 'physical-info' | 'computer-info';
  onButtonClick?: () => void;
}

type ExamRoomDetailType = ExamRoomDetailsBarProps['examRoomDetailType'];

const ITEM_CONFIG: Record<ExamRoomDetailType, { title: string; icon: React.ReactNode }> = {
  'physical-info': {
    title: 'ข้อมูลลักษณะทางกายภาพ',
    icon: <ChairAltOutlinedIcon />,
  },
  'computer-info': {
    title: 'ข้อมูลเกี่ยวกับอุปกรณ์คอมพิวเตอร์',
    icon: <DesktopWindowsOutlinedIcon />,
  },
};

export default function ExamRoomDetailsBar(props: Readonly<ExamRoomDetailsBarProps>) {
  const { examRoomDetailType, onButtonClick } = props;

  const { title, icon } = ITEM_CONFIG[examRoomDetailType];
  const buttonConfig = {
    text: 'ดูรายละเอียด',
    icon: <VisibilityOutlinedIcon />,
  };

  const handleButtonClick = () => {
    onButtonClick?.();
  };

  return (
    <Flex
      sx={(theme) => ({
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        p: theme.spacing(4),
        border: '1px solid',
        borderColor: theme.palette.grey[300],
        borderRadius: theme.shape.rounded(2),
      })}
    >
      <Flex sx={(theme) => ({ gap: theme.spacing(4), alignItems: 'center' })}>
        <Flex
          sx={(theme) => ({
            p: theme.spacing(2),
            alignItems: 'center',
            borderRadius: theme.shape.rounded(2),
            backgroundColor: theme.palette.grey[100],
            '& svg': {
              color: theme.palette.grey[600],
              fontSize: '24px',
            },
          })}
        >
          {icon}
        </Flex>
        <Text variant='h5'>{title}</Text>
      </Flex>
      <Button
        variant='outlined'
        size='small'
        color='secondary'
        sx={{
          minWidth: 'max-content',
        }}
        startIcon={buttonConfig.icon}
        onClick={handleButtonClick}
      >
        {buttonConfig.text}
      </Button>
    </Flex>
  );
}
